/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerListFolderContentsQueryResponse, ArtifactsControllerListFolderContentsPathParams, ArtifactsControllerListFolderContentsQueryParams, ArtifactsControllerListFolderContents400, ArtifactsControllerListFolderContents404 } from "../../models/documentArtifactsController/ArtifactsControllerListFolderContents";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { artifactsControllerListFolderContents } from "../../clients/document-artifactsService/artifactsControllerListFolderContents";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const artifactsControllerListFolderContentsQueryKey = (documentId: ArtifactsControllerListFolderContentsPathParams["documentId"], renditionId: ArtifactsControllerListFolderContentsPathParams["renditionId"], artifactId: ArtifactsControllerListFolderContentsPathParams["artifactId"], params: ArtifactsControllerListFolderContentsQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/files',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    artifactId: artifactId
  }
}, ...(params ? [params] : [])] as const;
export type ArtifactsControllerListFolderContentsQueryKey = ReturnType<typeof artifactsControllerListFolderContentsQueryKey>;
export function artifactsControllerListFolderContentsQueryOptions(documentId: ArtifactsControllerListFolderContentsPathParams["documentId"], renditionId: ArtifactsControllerListFolderContentsPathParams["renditionId"], artifactId: ArtifactsControllerListFolderContentsPathParams["artifactId"], params?: ArtifactsControllerListFolderContentsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = artifactsControllerListFolderContentsQueryKey(documentId, renditionId, artifactId, params);
  return queryOptions<ArtifactsControllerListFolderContentsQueryResponse, ResponseErrorConfig<ArtifactsControllerListFolderContents400 | ArtifactsControllerListFolderContents404>, ArtifactsControllerListFolderContentsQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && artifactId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return artifactsControllerListFolderContents(documentId, renditionId, artifactId, params, config);
    }
  });
}

/**
 * @description Returns a naturally-sorted list of files within a FOLDER artifact. Optional pageStart/pageEnd filter to files whose leading page number falls in the inclusive range (e.g. pageStart=1&pageEnd=50 for the first 50 source pages).
 * @summary List files in a folder artifact
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/files}
 */
export function useArtifactsControllerListFolderContents<TData = ArtifactsControllerListFolderContentsQueryResponse, TQueryData = ArtifactsControllerListFolderContentsQueryResponse, TQueryKey extends QueryKey = ArtifactsControllerListFolderContentsQueryKey>(documentId: ArtifactsControllerListFolderContentsPathParams["documentId"], renditionId: ArtifactsControllerListFolderContentsPathParams["renditionId"], artifactId: ArtifactsControllerListFolderContentsPathParams["artifactId"], params?: ArtifactsControllerListFolderContentsQueryParams, options: {
  query?: Partial<QueryObserverOptions<ArtifactsControllerListFolderContentsQueryResponse, ResponseErrorConfig<ArtifactsControllerListFolderContents400 | ArtifactsControllerListFolderContents404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? artifactsControllerListFolderContentsQueryKey(documentId, renditionId, artifactId, params);
  const query = useQuery({
    ...artifactsControllerListFolderContentsQueryOptions(documentId, renditionId, artifactId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArtifactsControllerListFolderContents400 | ArtifactsControllerListFolderContents404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}